import { createFileRoute, notFound } from '@tanstack/react-router';

import config from '@@config';

import { Editor } from './-components/Editor';

export const Route = createFileRoute('/_authenticated/plate/')({
    beforeLoad: () => {
        if (config.env === 'prod' || config.env === 'production') {
            throw notFound();
        }
    },
    component: Editor,
});
